// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {GlobalCreateMenu} from '@github-ui/global-create-menu'
import {useRef, useState} from 'react'

import {useDeferredPayloadSlice} from '../utils/DeferredNavPayloadContext'

interface LazyGlobalCreateMenuProps {
  /** Optional class applied to the menu's anchor button (e.g. responsive `hide-*` utilities). */
  className?: string
  /** Tags analytics events with the surface the menu is rendered in (e.g. `user_menu`). */
  analyticsLocation?: string
  /** Hide the dropdown chevron so only the leading `+` icon shows. */
  hideTrailingAction?: boolean
}

export function LazyGlobalCreateMenu({
  className,
  analyticsLocation,
  hideTrailingAction,
}: LazyGlobalCreateMenuProps = {}) {
  const [isOpen, setIsOpen] = useState(false)
  const anchorRef = useRef<HTMLElement | null>(null)
  const {data: createMenuProps, isPending} = useDeferredPayloadSlice('create_menu')

  return (
    <GlobalCreateMenu
      {...createMenuProps}
      className={className}
      analyticsLocation={analyticsLocation}
      hideTrailingAction={hideTrailingAction}
      isOpen={isOpen && !isPending}
      setIsOpen={setIsOpen}
      anchorRef={anchorRef}
      isLoading={isOpen && isPending}
    />
  )
}
